import { useQuery } from 'react-query';
import { getSubscriptionBlockUseCases } from '@subscriptions/composition';
import type { StoreViewDto } from '@subscriptions/application/dtos';

/**
 * Hook for listing stores available to the subscription block flows.
 *
 * In edit mode a `blockUuid` is passed so the backend returns the block's own
 * stores plus the ungrouped ones (it also keys the query separately per block).
 *
 * @param blockUuid - Optional block UUID (edit flow); omitted in create
 */
export const useStoresForBlock = (blockUuid?: string) => {
  const { fetchStoresForBlock } = getSubscriptionBlockUseCases();

  return useQuery<StoreViewDto[], Error>(
    ['subscriptions', 'stores', blockUuid ?? null],
    () => fetchStoresForBlock.execute(blockUuid),
    {
      refetchOnWindowFocus: false,
    },
  );
};
